module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "lg9": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-start": ""
    }
  }, [(!_vm.isLocalAdmin) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "readonly": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.terminal.companyId),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "companyId", $$v)
      },
      expression: "terminal.companyId"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.terminalName,
      "required": "",
      "rules": [function (v) { return !!v || 'Required'; }]
    },
    model: {
      value: (_vm.terminal.name),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "name", $$v)
      },
      expression: "terminal.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.terminalIdentifier
    },
    model: {
      value: (_vm.terminal.terminalIdentifier),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "terminalIdentifier", $$v)
      },
      expression: "terminal.terminalIdentifier"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.ipAddress,
      "required": "",
      "rules": [function (v) { return !!v || 'Required'; }]
    },
    model: {
      value: (_vm.terminal.ipAddress),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "ipAddress", $$v)
      },
      expression: "terminal.ipAddress"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.portNumber,
      "rules": [function (v) { return _vm.checkPort(v); }, function (v) { return !!v || 'Required'; }],
      "required": ""
    },
    model: {
      value: (_vm.terminal.port),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "port", $$v)
      },
      expression: "terminal.port"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.maxRetriesOnErrors,
      "rules": [function (v) { return _vm.checkMaxRetries(v); }, function (v) { return !!v || 'Required'; }],
      "required": ""
    },
    model: {
      value: (_vm.terminal.maxRetriesOnErrors),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "maxRetriesOnErrors", $$v)
      },
      expression: "terminal.maxRetriesOnErrors"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.hasPublicKeyBE,
      "color": "primary mx-0"
    },
    on: {
      "click": function($event) {
        _vm.isTerminal = true;
        _vm.updatePassword = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.updatePassword) + "\n          ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "px-3": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.labels.automaticPrint))]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": _vm.$lang.labels.merchantPrint,
      "color": "primary",
      "hide-details": ""
    },
    model: {
      value: (_vm.terminal.automaticPrintMerchantReceipt),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "automaticPrintMerchantReceipt", $$v)
      },
      expression: "terminal.automaticPrintMerchantReceipt"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": _vm.$lang.labels.customerPrint,
      "color": "primary",
      "hide-details": ""
    },
    model: {
      value: (_vm.terminal.automaticPrintCustomerReceipt),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "automaticPrintCustomerReceipt", $$v)
      },
      expression: "terminal.automaticPrintCustomerReceipt"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "px-3": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.labels.switchReceiptType))]), _vm._v(" "), _c('v-radio-group', {
    model: {
      value: (_vm.terminal.switchReceiptType),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "switchReceiptType", $$v)
      },
      expression: "terminal.switchReceiptType"
    }
  }, [_c('v-radio', {
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.merchant,
      "value": "merchant"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.customer,
      "value": "customer"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3 px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'paymentTerminals'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-3",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n        ")])], 1)], 1), _vm._v(" "), (_vm.updatePassword) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.updatePassword),
      callback: function($$v) {
        _vm.updatePassword = $$v
      },
      expression: "updatePassword"
    }
  }, [_c('change-password', {
    attrs: {
      "isTerminal": _vm.isTerminal
    },
    on: {
      "close": function($event) {
        _vm.updatePassword = false;
        _vm.isTerminal = false;
      }
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2422d5ff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/paymentTerminals/PaymentTerminalDetails.vue
// module id = 391
// module chunks = 35